<template>
 <a-config-provider :locale="locale">
    <div id="app">
        <Header></Header>
        <router-view></router-view>
        <!-- <Register></Register> -->
        <Footer></Footer>
    </div>
 </a-config-provider>
</template>
<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
// import Register from './view/register.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  components: {
    Header,
    Footer,
    // Register
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      locale: zhCN,
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!', this.form);
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
}
#header{
  font-family: tahoma,arial,\5b8b\4f53,sans-serif;
}
.has-error .ant-form-explain{
    margin-left: 12px;
    position: relative;
    top: 4px;
    font-size: 13px;
}
.ant-calendar-picker-input .ant-calendar-range-picker-input{
  text-align: left;
}
.ant-calendar-picker-input span+.ant-calendar-range-picker-input{
  margin-left: 11px;
}
.ant-input[disabled]{
    color: rgba(0, 0, 0, 0.45);
    background-color: #fff;
}
.ant-radio-disabled + span{
    color: rgba(0, 0, 0, 0.45);
}
.ant-radio-disabled .ant-radio-inner::after{
  background-color: rgba(0, 0, 0, 0.45);
}
.ant-radio-disabled .ant-radio-inner{
  background-color: #ffffff;
}
.ant-message{
  z-index: 50000 !important;
}
.ant-modal-mask{
   z-index: 40000 !important; 
}
.ant-modal-wrap{
  z-index: 40001 !important;
}
</style>
